var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// tailwind.config.js
var _require = require('tailwindcss/defaultConfig'),
  theme = _require.theme,
  variants = _require.variants;
var customWidths = {
  '10vw': '10vw',
  '20vw': '20vw',
  '30vw': '30vw',
  '40vw': '40vw',
  '50vw': '50vw',
  '60vw': '60vw',
  '70vw': '70vw',
  '80vw': '80vw',
  '90vw': '90vw',
  14: '3.5rem',
  36: '9rem',
  232: '58rem',
  '840px': '840px',
  0: 0
};
var customHeights = {
  '10vh': '10vh',
  '20vh': '20vh',
  '30vh': '30vh',
  '40vh': '40vh',
  '50vh': '50vh',
  '60vh': '60vh',
  '70vh': '70vh',
  '80vh': '80vh',
  '90vh': '90vh',
  14: '3.5rem',
  18: '4.5rem',
  36: '9rem',
  40: '10rem',
  72: '18rem',
  '500px': '500px',
  '1/7': '14.285714%',
  0: 0
};
module.exports = {
  purge: false,
  darkMode: 'media',
  theme: _objectSpread(_objectSpread({}, theme), {}, {
    screens: _objectSpread(_objectSpread({}, theme.screens), {}, {
      '2xl': '1536px',
      '3xl': '1800px'
    }),
    inset: _objectSpread(_objectSpread({}, theme.inset), {}, {
      3: '0.75rem'
    }),
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      primary: {
        "default": 'var(--color-primary)',
        active: 'var(--color-primary-active)'
      },
      secondary: '#B6BDC2',
      green: 'var(--color-green)',
      red: 'var(--color-red)',
      yellow: 'var(--color-yellow)',
      orange: 'var(--color-orange)',
      purple: 'var(--color-purple)',
      teal: 'var(--color-teal)',
      white: 'var(--color-white)',
      black: 'var(--color-black)',
      gray: {
        'ultra-light': 'var(--color-text-ultra-light)',
        light: 'var(--color-text-light)',
        medium: 'var(--color-text-medium)',
        dark: 'var(--color-text-dark)',
        divider: 'var(--color-divider)'
      }
    }),
    width: function width(_theme) {
      return _objectSpread(_objectSpread(_objectSpread({}, theme.width(_theme)), customWidths), customHeights);
    },
    height: function height(_theme) {
      return _objectSpread(_objectSpread(_objectSpread({}, theme.height(_theme)), customHeights), customHeights);
    },
    minWidth: _objectSpread(_objectSpread({}, theme.minWidth), customWidths),
    minHeight: _objectSpread(_objectSpread({}, theme.minHeight), customHeights),
    maxWidth: function maxWidth(_theme, _ref) {
      var breakpoints = _ref.breakpoints;
      return _objectSpread(_objectSpread({}, theme.maxWidth(_theme, {
        breakpoints: breakpoints
      })), {}, {
        xxs: '15rem'
      });
    },
    maxHeight: _objectSpread(_objectSpread({}, theme.maxHeight), customHeights),
    extend: {
      spacing: {
        '1/2': '50%',
        7: '1.75rem',
        28: '7rem'
      },
      borderRadius: {
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem'
      },
      padding: {
        13: '3.25rem'
      },
      borderOpacity: {
        15: 0.15
      },
      borderWidth: {
        1: '1px'
      },
      opacity: {
        30: '0.3'
      },
      borderColor: {
        'ultra-light': 'var(--color-text-ultra-light)',
        light: 'var(--color-text-light)',
        medium: 'var(--color-text-medium)',
        dark: 'var(--color-text-dark)',
        "default": 'var(--color-divider)',
        primary: 'var(--color-primary)',
        'primary-active': 'var(--color-primary-active)',
        secondary: 'var(--color-bg-secondary)',
        red: 'var(-color-red)'
      },
      textColor: {
        'ultra-light': 'var(--color-text-ultra-light)',
        light: 'var(--color-text-light)',
        medium: 'var(--color-text-medium)',
        dark: 'var(--color-text-dark)'
      },
      backgroundColor: {
        app: 'var(--color-bg-primary)',
        secondary: 'var(--color-bg-secondary)',
        card: 'var(--color-bg-card)',
        'ultra-light': 'var(--color-bg-ultra-light)',
        light: 'var(--color-text-light)',
        medium: 'var(--color-text-medium)',
        dark: 'var(--color-text-dark)',
        error: 'var(--color-bg-error)',
        highlight: 'var(--color-bg-highlight)',
        divider: 'var(--color-divider)',
        lightrey: '#EBEBEB',
        pane: 'var(--color-bg-pane-primary)'
      },
      boxShadow: {
        lg: 'var(--shadow-lg)',
        'lg-t': 'var(--shadow-lg-t)',
        hover: '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035)',
        shallow: 'var(--shadow-shallow)',
        deep: 'var(--shadow-deep)',
        'deep-l': 'var(--shadow-deep-l)',
        'deep-r': 'var(--shadow-deep-r)',
        'deep-t': 'var(--shadow-deep-t)'
      },
      maxWidth: function maxWidth(theme, _ref2) {
        var breakpoints = _ref2.breakpoints;
        return _objectSpread(_objectSpread({}, customWidths), breakpoints(theme('screens')));
      },
      cursor: {
        ewResize: 'ew-resize'
      }
    }
  }),
  variants: {
    fontSize: [].concat(_toConsumableArray(variants.fontSize), ['important']),
    fontWeight: [].concat(_toConsumableArray(variants.fontWeight), ['important', 'first']),
    textColor: [].concat(_toConsumableArray(variants.textColor), ['important', 'disabled', 'dark', 'dark-hover', 'dark-disabled', 'force-dark', 'force-light']),
    textTransform: [].concat(_toConsumableArray(variants.textTransform), ['important']),
    width: [].concat(_toConsumableArray(variants.width), ['important']),
    height: [].concat(_toConsumableArray(variants.height), ['important']),
    margin: [].concat(_toConsumableArray(variants.margin), ['important', 'first', 'last']),
    minWidth: [].concat(_toConsumableArray(variants.minWidth), ['important']),
    minHeight: [].concat(_toConsumableArray(variants.minHeight), ['important']),
    maxWidth: [].concat(_toConsumableArray(variants.maxWidth), ['important']),
    maxHeight: [].concat(_toConsumableArray(variants.maxHeight), ['important']),
    padding: [].concat(_toConsumableArray(variants.padding), ['important', 'first', 'last']),
    backgroundColor: [].concat(_toConsumableArray(variants.backgroundColor), ['important', 'disabled', 'odd', 'even', 'dark', 'dark-hover', 'dark-disabled', 'dark-important', 'force-dark']),
    borderCollapse: [].concat(_toConsumableArray(variants.borderCollapse), ['important']),
    borderColor: [].concat(_toConsumableArray(variants.borderColor), ['important', 'hover']),
    borderRadius: [].concat(_toConsumableArray(variants.borderRadius), ['important', 'first', 'last']),
    borderStyle: [].concat(_toConsumableArray(variants.borderStyle), ['important']),
    borderWidth: [].concat(_toConsumableArray(variants.borderWidth), ['important', 'first', 'last', 'focus', 'dark', 'hover']),
    cursor: [].concat(_toConsumableArray(variants.cursor), ['disabled', 'important']),
    opacity: [].concat(_toConsumableArray(variants.opacity), ['disabled', 'important', 'dark', 'dark-disabled']),
    stroke: [].concat(_toConsumableArray(variants.stroke), ['important']),
    overflow: [].concat(_toConsumableArray(variants.overflow), ['important']),
    zIndex: [].concat(_toConsumableArray(variants.zIndex), ['hover']),
    boxShadow: [].concat(_toConsumableArray(variants.boxShadow), ['dark', 'dark-hover']),
    justifyContent: [].concat(_toConsumableArray(variants.justifyContent), ['important'])
  },
  plugins: [
  // Multiple lines truncation
  function (_ref3) {
    var addUtilities = _ref3.addUtilities;
    var lineNumbers = [2, 3];
    addUtilities(lineNumbers.reduce(function (prev, lineNumber) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, ".truncate-".concat(lineNumber), {
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': "".concat(lineNumber),
        overflow: 'hidden'
      }));
    }, {}));
  },
  // Custom variants
  function (_ref4) {
    var addVariant = _ref4.addVariant,
      e = _ref4.e;
    addVariant('important', function (_ref5) {
      var container = _ref5.container;
      container.walkRules(function (rule) {
        rule.selector = ".\\!".concat(rule.selector.slice(1));
        rule.walkDecls(function (decl) {
          decl.important = true;
        });
      });
    });
    addVariant('force-dark', function (_ref6) {
      var container = _ref6.container,
        separator = _ref6.separator;
      var cssVarPrefix = ['--color', '--shadow'];
      container.walkRules(function (rule) {
        rule.selector = ".".concat(e("force-dark".concat(separator).concat(rule.selector.slice(1))));
        rule.walkDecls(function (decl) {
          if (decl.value) {
            for (var _i = 0, _cssVarPrefix = cssVarPrefix; _i < _cssVarPrefix.length; _i++) {
              var prefix = _cssVarPrefix[_i];
              var index = decl.value.indexOf(prefix);
              if (index !== -1) {
                decl.value = "".concat(decl.value.slice(0, index)).concat(prefix, "-dark-").concat(decl.value.slice(index + prefix.length + 1));
              }
            }
          }
        });
      });
    });
    addVariant('force-light', function (_ref7) {
      var container = _ref7.container,
        separator = _ref7.separator;
      var cssVarPrefix = ['--color', '--shadow'];
      container.walkRules(function (rule) {
        rule.selector = ".".concat(e("force-dark".concat(separator).concat(rule.selector.slice(1))));
        rule.walkDecls(function (decl) {
          if (decl.value) {
            for (var _i2 = 0, _cssVarPrefix2 = cssVarPrefix; _i2 < _cssVarPrefix2.length; _i2++) {
              var prefix = _cssVarPrefix2[_i2];
              var index = decl.value.indexOf(prefix);
              if (index !== -1) {
                decl.value = "".concat(decl.value.slice(0, index)).concat(prefix, "-light-").concat(decl.value.slice(index + prefix.length + 1));
              }
            }
          }
        });
      });
    });
    addVariant('dark', function (_ref8) {
      var modifySelectors = _ref8.modifySelectors,
        separator = _ref8.separator;
      modifySelectors(function (_ref9) {
        var className = _ref9.className;
        var modified = e("dark".concat(separator).concat(className));
        return ".dark .".concat(modified);
      });
    });
    addVariant('dark-hover', function (_ref10) {
      var modifySelectors = _ref10.modifySelectors,
        separator = _ref10.separator;
      modifySelectors(function (_ref11) {
        var className = _ref11.className;
        var modified = e("dark".concat(separator, "hover").concat(separator).concat(className));
        return ".dark .".concat(modified, ":hover");
      });
    });
    addVariant('dark-disabled', function (_ref12) {
      var modifySelectors = _ref12.modifySelectors,
        separator = _ref12.separator;
      modifySelectors(function (_ref13) {
        var className = _ref13.className;
        var modified = e("dark".concat(separator, "disabled").concat(separator).concat(className));
        return ".dark .".concat(modified, ":disabled");
      });
    });
    addVariant('dark-important', function (_ref14) {
      var container = _ref14.container,
        separator = _ref14.separator;
      container.walkRules(function (rule) {
        rule.selector = ".dark .\\!".concat(e("dark".concat(separator).concat(rule.selector.slice(1))));
        rule.walkDecls(function (decl) {
          decl.important = true;
        });
      });
    });
  }]
};
//# sourceMappingURL=tailwind.config.js.map